import { default as headings } from './Headings'
import { default as figure } from './Figure'
import { default as figcaption } from './Figcaption'
import { default as code } from './CodeBlock'
import { default as sitemeta } from './SiteMeta'
import {
  // Grid,
  // Card,
  // Box,
  // Text,
  Button,
  // Heading,
  // Link,
  // Image,
  // Label,
  // Input,
  // Checkbox,
  // Select,
  // Textarea,
  // Flex,
  // Radio,
  // Slider,
  // Spinner,
  // Badge,
  // NavLink,
  // Alert,
  // Message,
} from "theme-ui";

const Mdx = {
  figure,
  figcaption,
  pre: props => props.children,
  code,
  sitemeta,
  ...headings,
  Button
}

export default Mdx